export const FETCH_USER = "fetch_user";
export const FETCH_CAMPAIGNS = "fetch_campaigns";
export const DELETE_CAMPAIGN_SUCCESSFUL = "delete_campaign_successful";
export const DELETE_CAMPAIGN_FAILED = "delete_campaign_failed";

export const SEND_CAMPAIGN_FAILED = "send_campaigns_failed";
export const SEND_CAMPAIGN = "send_campaigns";
export const DRAFT_CAMPAIGN = "draft_campaign";

export const FETCH_RECIPIENTS = "fetch_recipients";

export const SAVE_RECIPIENT = "save_recipient";
export const SAVE_RECIPIENT_FAILED = "save_recipient_failed";
export const SAVE_RECIPIENT_DUPLICATE = "save_recipient_duplicate";

export const LOGIN_SUCCESS = "login_success";
export const LOGIN_ERROR = "login_error";
export const SIGNOUT_SUCCESS = "signout_success";
export const SIGNOUT_FAILED = "signout_failed";
export const SIGNUP_SUCCESS = "signup_success";
export const SIGNUP_FAILED = "signup_failed";
export const DELETE_RECIPIENT_FAILED = "delete_recipient_failed";
export const DELETE_RECIPIENT_SUCCESS = "delete_recipient_success";

export const SEND_SHOPIFY_CONFIG = "send_shopify_config";
export const DELETE_SHOPIFY_CONFIG = "delete_shopify_config";
